<div class="request-jump-detail">
  <div class="wrapper-breadcrumbs">
    <scc-dsm3-nav-breadcrumbs [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
  </div>

  <div class="wrapper-detail-title">
    <app-detail-title [viewModel]="detailTitleViewModel" (updateAction)="updateAction()"></app-detail-title>
  </div>

  <div class="wrapper-request-information">
    <app-request-information [viewModel]="requestInformationViewModel" (clickItem)="downloadAttachment($event)">
    </app-request-information>
  </div>

  <app-request-state
    [viewModel]="requestStateViewModel"
    (submit)="submit()"
    (clickItem)="downloadAttachment($event)"
    (clickBack)="back()"
    [validForm]="checkValidForm()"
  >
  </app-request-state>

  <app-document-history
    *ngIf="attachments.length > 0"
    [attachments]="attachments"
    (clickItem)="downloadAttachment($event)"
  ></app-document-history>

  <ng-template #templateModalReopenRequest>
    <app-reopen-request
      [viewModel]="reopenRequestViewModel"
      (submissionClick)="submitReopenForm()"
      (cancelClick)="closeReopenFormModal()"
    >
    </app-reopen-request>
  </ng-template>

  <ng-template #templateModalCancelRequest>
    <app-cancel-request
      [formGroup]="cancelRequestFormGroup"
      (submissionClick)="submitCancelForm()"
      (cancelClick)="closeCancelFormModal()"
    >
    </app-cancel-request>
  </ng-template>
</div>
